import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mapings = new Map<ProfiBazaAPIModels.DocumentSubjectKind, string>([
	[ProfiBazaAPIModels.DocumentSubjectKind.JST, 'JST'],
	[ProfiBazaAPIModels.DocumentSubjectKind.MZ, 'MZ'],
]);

export const map = (value: ProfiBazaAPIModels.DocumentSubjectKind): string =>
	mapings.get(value) ?? '';
